var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "check_svg__path-1",
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m6.155 7.988-7.451 9.562c-.06.059-.156.188-.274.188-.123 0-.203-.086-.273-.156S5.93 13.516 5.93 13.516l-.08-.08a.3.3 0 0 1-.059-.172c0-.064.027-.123.059-.171a444.475 444.475 0 0 1 1.36-1.43c.07-.07.13-.161.258-.161.134 0 .22.112.284.177s2.41 2.32 2.41 2.32l5.963-7.661a.3.3 0 0 1 .188-.075.3.3 0 0 1 .187.07l1.64 1.29a.3.3 0 0 1 .069.188.28.28 0 0 1-.054.176"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "check_svg__icons-badges-variations",
    transform: "translate(-405 -239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check_svg__icons/check",
    transform: "translate(405 239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check_svg__color/gray/70-4A4A4A"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "check_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#check_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#check_svg__path-1",
    id: "check_svg__Mask",
    fill: "#FDFDFD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "check_svg__color/black-tint/0-000000",
    fill: "#000",
    mask: "url(#check_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check_svg__gray-70-4A4A4A",
    d: "M0 0h24v24H0z"
  }))))))));
};
export default SvgCheck;